// @flow
import { type Effect, type Event } from 'effector'
import type { Fail } from 'core/types'
import type { PhonesStore } from '../types'
import { PhoneDomain } from './domain'

export const fetchPhones: Event<void> = PhoneDomain.event('get phones')

export const fetchRequest: Effect<void, PhonesStore, Fail> = PhoneDomain.effect('fetching phones', {
  async handler() {
    return { contactPhoneNumber: window?.app_options?.contact_phone_number || '88003020412' }
  },
})
